import PartnerManage from './PartnerManage';

export default PartnerManage;